import SimpleSchema from 'simpl-schema';

import store from 'config/configureStore';
import { findOffenseConflict } from 'simpl-schema-validation/helpers/Codes/offenseConflicts';

export const incidentAllOffensesSchema = () => {
  SimpleSchema.setDefaultMessages({
    messages: {
      en: store?.store.getState().incident.ibrsValidationRules?.allOffenses || {},
    },
  });

  return new SimpleSchema({
    ucrCodes: {
      type: Array,
      optional: true,
      custom() {
        // Rule 27 is INCIDENT-level and deliberately unchanged: a justifiable
        // homicide incident must carry exactly one offense.
        const ucrCodes = Array.isArray(this.value) ? this.value : [];
        if (ucrCodes.includes('09C') && ucrCodes.length > 1) {
          return 'NIBRS-2019.2-27';
        }

        // Error 478 is PER VICTIM (DE-24). Evaluating it incident-wide is a
        // strict superset and produced false positives whenever conflicting
        // offenses belonged to different victims.
        const byVictim = this.field('ucrCodesByVictim').value;
        if (!Array.isArray(byVictim)) return undefined;

        for (const victim of byVictim) {
          const conflict = findOffenseConflict(victim && victim.codes);
          if (conflict) return conflict.rule;
        }
        return undefined;
      },
    },
    'ucrCodes.$': {
      type: String,
      optional: true,
      blackbox: true,
      custom() {},
    },
    ucrCodesByVictim: {
      type: Array,
      optional: true,
      custom() {},
    },
    'ucrCodesByVictim.$': {
      type: Object,
      optional: true,
      blackbox: true,
    },
    biasMotivationCodes: {
      type: Array,
      optional: true,
      custom() {
        const biasMotivationCodes = [];
        this.value.forEach((value) => {
          if (!biasMotivationCodes.includes(value)) {
            biasMotivationCodes.push(value);
          }
        });

        // NIBRS-2019.2-35: Offense Factor Bias Motivation
        if (biasMotivationCodes.length !== this.value.length) {
          return 'NIBRS-2019.2-35';
        }
      },
    },
    'biasMotivationCodes.$': {
      type: String,
      optional: true,
      blackbox: true,
      custom() {},
    },
    criminalActivityCodes: {
      type: Array,
      optional: true,
      custom() {
        const criminalActivityCodes = [];
        this.value.forEach((value) => {
          if (!criminalActivityCodes.includes(value)) {
            criminalActivityCodes.push(value);
          }
        });

        // NIBRS-2019.2-44: Criminal Activity/Gang Information
        if (criminalActivityCodes.length !== this.value.length) {
          return 'NIBRS-2019.2-44';
        }
      },
    },
    'criminalActivityCodes.$': {
      type: String,
      optional: true,
      blackbox: true,
      custom() {},
    },
    offenderSuspectedOfUsingCodes: {
      type: Array,
      optional: true,
      custom() {
        const offenderSuspectedOfUsingCodes = [];
        this.value.forEach((value) => {
          if (!offenderSuspectedOfUsingCodes.includes(value)) {
            offenderSuspectedOfUsingCodes.push(value);
          }
        });

        // NIBRS-2019.2-32: Offense Factor
        if (offenderSuspectedOfUsingCodes.length !== this.value.length) {
          return 'NIBRS-2019.2-32';
        }
      },
    },
    'offenderSuspectedOfUsingCodes.$': {
      type: String,
      optional: true,
      blackbox: true,
      custom() {},
    },
    forceCategoryCodes: {
      type: Array,
      optional: true,
      custom() {
        const forceCategoryCodes = [];
        this.value.forEach((value) => {
          if (!forceCategoryCodes.includes(value)) {
            forceCategoryCodes.push(value);
          }
        });
        // NIBRS-2019.2-50: Weapon/Force Involved
        if (forceCategoryCodes.length !== this.value.length) {
          return 'NIBRS-2019.2-50';
        }
      },
    },
    'forceCategoryCodes.$': {
      type: String,
      optional: true,
      blackbox: true,
      custom() {},
    },
  });
};
